export function initPaymentHistoryPagination() {
	const mobileContainer = document.getElementById('payment-history-mobile');
	const desktopContainer = document.getElementById('payment-history-desktop');
	const paginationContainer = document.getElementById('payment-history-pagination');
	const prevBtn = document.getElementById('btn-payment-history-prev');
	const nextBtn = document.getElementById('btn-payment-history-next');
	const pageNumbers = document.getElementById('payment-history-page-numbers');

	if (!mobileContainer || !desktopContainer || !paginationContainer || !prevBtn || !nextBtn || !pageNumbers) return;

	const containers = [mobileContainer, desktopContainer];
	let currentPage = 1;
	let maxPages = parseInt(paginationContainer.dataset.maxPages) || 1;
	let isLoading = false;

	const setLoadingState = (opacity) => {
		containers.forEach(container => container.style.opacity = opacity);
	};

	async function loadPage(page) {
		if (page < 1 || page > maxPages || isLoading) return;

		isLoading = true;
		prevBtn.disabled = nextBtn.disabled = true;
		pageNumbers.querySelectorAll('button').forEach(btn => btn.disabled = true);
		setLoadingState('0.5');

		try {
			const formData = new FormData();
			formData.append('action', 'wpcore_payment_history_pagination');
			formData.append('nonce', wpcore.nonce);
			formData.append('page', page);

			const response = await fetch(wpcore.ajaxUrl, { method: 'POST', body: formData });
			const data = await response.json();

			if (data.success) {
				currentPage = data.data.current_page;
				maxPages = data.data.max_pages;
				mobileContainer.innerHTML = data.data.mobile_html || '';
				desktopContainer.innerHTML = data.data.desktop_html || '';
				updatePagination();
			}
		} catch (error) {
			console.error('Error loading payment history:', error);
		} finally {
			setLoadingState('1');
			isLoading = false;
		}
	}

	function updatePagination() {
		// Update prev/next buttons state
		prevBtn.disabled = currentPage <= 1;
		prevBtn.dataset.page = currentPage - 1;
		nextBtn.disabled = currentPage >= maxPages;
		nextBtn.dataset.page = currentPage + 1;
		paginationContainer.dataset.maxPages = maxPages;

		// Update page number buttons
		const startPage = Math.max(1, currentPage - 2);
		const endPage = Math.min(maxPages, currentPage + 2);
		pageNumbers.innerHTML = Array.from({ length: endPage - startPage + 1 }, (_, i) => {
			const page = startPage + i;
			const isActive = page === currentPage;
			return `<button class="payment-history-page-btn w-10 h-10 flex items-center justify-center text-sm font-medium rounded-md transition-colors ${isActive ? 'bg-primary-500 text-white' : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'}" data-page="${page}">${page}</button>`;
		}).join('');
	}

	prevBtn.addEventListener('click', () => {
		if (currentPage > 1) loadPage(currentPage - 1);
	});
	nextBtn.addEventListener('click', () => {
		if (currentPage < maxPages) loadPage(currentPage + 1);
	});
	pageNumbers.addEventListener('click', (e) => {
		if (e.target.classList.contains('payment-history-page-btn')) {
			const page = parseInt(e.target.dataset.page);
			if (page !== currentPage && page >= 1 && page <= maxPages) {
				loadPage(page);
			}
		}
	});
}

